<!-- Header -->
<ion-header
  class="ion-no-border"
  [class.ion-header-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-header-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-header-modal-mobile]="platformType === platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        data-cy="inventory-item-modal-close-button"
        (click)="dismissModal()"
      >
        <ion-icon
          data-cy="inventory-item-modal-close-button-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      <span
        *ngIf="
          inventoryItem?.customUOM !== undefined &&
            inventoryItem?.customUOM !== '';
          else addTitle
        "
        >{{
          'i18n.inventory.inventoryWorksheet.inventoryCustomModal.edit'
            | translate
        }}</span
      >
      <ng-template #addTitle>
        <span>{{
          'i18n.inventory.inventoryWorksheet.inventoryCustomModal.add'
            | translate
        }}</span>
      </ng-template>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="inventory-item-modal_content"
  [class.ion-content-modal-desktop]="platformType === platformEnum.desktop"
  [class.ion-content-modal-tablet]="platformType === platformEnum.tablet"
  [class.ion-content-modal-mobile]="platformType === platformEnum.mobile"
>
  <ion-label id="custom-uom-product-name" class="custom-uom-product-name">
    <span>
      for {{ inventoryItem?.productName | truncateWithEllipsis: 30 }}
    </span>
  </ion-label>

  <ion-item
    class="custom-uom-item"
    [class.error-highlight]="
      existingLabels.includes(customUnitInput.value.toUpperCase())
    "
  >
    <ion-input
      aria-labelledby="custom-uom-product-name"
      class="custom-uom-input"
      maxlength="8"
      min="0"
      mode="ios"
      type="text"
      placeholder="{{
        'i18n.inventory.inventoryWorksheet.inventoryCustomModal.inputPlaceholder'
          | translate
      }}"
      alphanumeric
      [formControl]="customUnitInput"
    >
    </ion-input>
    <span slot="error">
      {{
        'i18n.inventory.inventoryWorksheet.inventoryCustomModal.unitError'
          | translate
      }}
    </span>
  </ion-item>
  <span
    class="error"
    *ngIf="
      customUnitInput.valid &&
      existingLabels.includes(customUnitInput.value.toUpperCase())
    "
  >
    {{
      'i18n.inventory.inventoryWorksheet.inventoryCustomModal.uniqueError'
        | translate
    }}
  </span>
</ion-content>
<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="inventory-information-modal-desktop-tablet-close-button"
        [ngClass]="
          platformType === platformEnum.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="submit-modal-btn"
        data-cy="submit-selected-items-modal-button"
        [ngClass]="
          customUnitInput.valid &&
          customUnitInput.value !== '' &&
          customUnitInput.value.toUpperCase() !==
            inventoryItem?.customUOM?.toUpperCase() &&
          !existingLabels.includes(customUnitInput.value.toUpperCase())
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-disabled-dsktp-tblt-modal-button'
        "
        (click)="handleSubmit()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
